// extracted by mini-css-extract-plugin
module.exports = {"hotelierLink":"ForHoteliersLink_hotelierLink__XExKJ","hotelierIcon":"ForHoteliersLink_hotelierIcon__2-azB","dark":"ForHoteliersLink_dark__3S7fg"};